<template>

    <div id="projectContainer" class="is-clipped " :class="embed?'lb-embed-height':'lb-full-height'">
        
        <div class="columns is-marginless">

            <router-view />

            

        </div>
         
        <project-modal-share
            :unique="true"
            v-if="showResumeModal"
            :content="$store.getters.project"
            @share="showShareModal = true"
            class="project-resume"
        />

    </div>
    
</template>

<script>

import store from '@/store/index';
import _ from 'underscore';
import ProjectModalShare from '@/components/ProjectModalShare';

export default {
    name: 'ShareProject',
    components: {
        ProjectModalShare
    },
    
    props: {
        projectId: { type: String, default: undefined },
    },
    metaInfo() {
        // if no subcomponents specify a metaInfo.title, this title will be used
        /*return {
            title: this.project.title,
            titleTemplate: '%s - eduloc360',
            meta: [
                // Twitter Card
                { name: 'twitter:card', content: 'summary' },
                { name: 'twitter:title', content: this.project.title },
                {
                    name: 'twitter:description',
                    content: this.project.description,
                },
                // image must be an absolute path
                { name: 'twitter:image', content: this.projectBackgroundImage },
                // Facebook OpenGraph
                { property: 'og:title', content: this.project.title },
                { property: 'og:site_name', content: 'eduloc360' },
                { property: 'og:type', content: 'website' },
                { property: 'og:image', content: this.projectBackgroundImage },
                {
                    property: 'og:description',
                    content: this.project.description,
                },
            ],
        };*/
        return {
            title: this.$store.getters.project.title,
            titleTemplate: '%s - EDULOC 360',
            meta: [
                // Twitter Card
                { name: 'twitter:card', content: 'summary' },
                { name: 'twitter:title', content: this.$store.getters.project.title },
                {
                    name: 'twitter:description',
                    content: this.$store.getters.project.description,
                },
                // image must be an absolute path
                { name: 'twitter:image', content: this.projectBackgroundImage },
                // Facebook OpenGraph
                { property: 'og:title', content: this.$store.getters.project.title },
                { property: 'og:site_name', content: 'EDULOC 360' },
                { property: 'og:type', content: 'website' },
                { property: 'og:image', content: this.projectBackgroundImage },
                {
                    property: 'og:description',
                    content: this.$store.getters.project.description,
                },
            ],
        };
    },
    data() {
        return {
            

            embed: this.$route.meta.embed,
            hideLogin: this.$route.meta.hideLogin,
            showResumeModal: false,
            

        };
    },
    computed: {
        
        isMobile(){
            return this.$mq=="mobile"
        },
        
        projectType() {
            return this.$store.getters.project.type;
        },
        isProjectAdmin() {
            return (
                this.$store.getters.isAdmin ||
                this.project.accessLevel == 'administrator'
            );
        },
        
        isAnonymous(){
            return this.$store.getters.isAnonymous;
        },
        isAnnonymousParticipation(){
            if( this.project.allowAnonymous==true){
                return this.project.accessLevel != 'read' && this.$store.getters.isAnonymous
            }
            return false;
        },
        
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        project() {
            return this.$store.getters.project;
        },
        itemsSource() {
            return this.$store.getters.projectContent;
        },
        projectBackgroundImage() {
            return this.$store.getters.projectImage || this.logo;
        },
        
    },
    watch: {
        
    },
    mounted: function () {
        /*setTimeout(() => {
            // this.$Progress.start();
        }, 500);*/
        store
        .dispatch('fetchProject', this.$route.params.projectId)
        .then(()=>{
            // console.log("project fetched",this.project)

            store
            .dispatch('fetchProjectContent', {
                _id: this.$route.params.projectId,
            })
            .catch(() => {
                console.error('failed to fetch project content');
            })
            .finally(() => {
                // this.$Progress.finish();
                // console.log("emiting info")
                this.showResumeModal=true;
            });

            

            
        })
        .catch((e) => {
            console.error('failed to fetch project', e.status || e);
            this.showErrorPage = true;
        });

        

        
        
    },
    beforeDestroy() {
    },
    destroyed() {
        this.$store.dispatch('cleanProject');
        
    },

    methods: {
        
    },
};
</script>

<style scoped lang="css">
@import '../assets/css/project.css';
@import '../assets/css/map.css';
@import '../assets/css/tippyedulocblue.css';
@import '../assets/css/swal-eduloc.css';

</style>
